import { useState } from "react";
import { useDispatch } from "react-redux";
import InputText from "../../../components/Input/InputText";
import ErrorText from "../../../components/Typography/ErrorText";
import { showNotification } from "../../common/headerSlice";
import api from "../../../utils/axios";
import { triggerRefresh } from "../../../utils/refreshRegistry";

const INITIAL_SCHEDULE_OBJ = {
  weekday: "",
  time: "",
  meeting: "",
  place: "",
  url: "",
};

function AddScheduleModalBody({ closeModal }) {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [scheduleObj, setScheduleObj] = useState(INITIAL_SCHEDULE_OBJ);
  const [saving, setSaving] = useState(false);

  const saveNewSchedule = async () => {
    setSaving(true);
    setErrorMessage("");

    try {
      await api.post("/api/schedules", {
        weekday: scheduleObj.weekday,
        time: scheduleObj.time,
        meeting: scheduleObj.meeting,
        place: scheduleObj.place,
        url: scheduleObj.url,
      });
      dispatch(showNotification({ message: "New Schedule Row Added!", status: 1 }));
      closeModal();
      triggerRefresh("schedules");
    } catch (error) {
      console.error("Error saving schedule row:", error);
      const errorMsg =
        error.response?.data?.message ||
        "Failed to save schedule row. Please try again.";
      setErrorMessage(errorMsg);
      dispatch(showNotification({ message: errorMsg, status: 0 }));
    } finally {
      setSaving(false);
    }
  };

  const updateFormValue = ({ updateType, value }) => {
    setErrorMessage("");
    setScheduleObj({ ...scheduleObj, [updateType]: value });
  };

  return (
    <>
      <InputText
        type="text"
        defaultValue={scheduleObj.weekday}
        updateType="weekday"
        containerStyle="mt-4"
        labelTitle="Weekday"
        updateFormValue={updateFormValue}
      />
      <InputText
        type="text"
        defaultValue={scheduleObj.time}
        updateType="time"
        containerStyle="mt-4"
        labelTitle="Time"
        placeholder="e.g. 7:00 PM"
        updateFormValue={updateFormValue}
      />
      <InputText
        type="text"
        defaultValue={scheduleObj.meeting}
        updateType="meeting"
        containerStyle="mt-4"
        labelTitle="Meeting"
        updateFormValue={updateFormValue}
      />
      <InputText
        type="text"
        defaultValue={scheduleObj.place}
        updateType="place"
        containerStyle="mt-4"
        labelTitle="Place"
        updateFormValue={updateFormValue}
      />
      <InputText
        type="text"
        defaultValue={scheduleObj.url}
        updateType="url"
        containerStyle="mt-4"
        labelTitle="Meeting Link"
        placeholder="https://..."
        updateFormValue={updateFormValue}
      />

      <ErrorText styleClass="mt-8">{errorMessage}</ErrorText>
      <div className="modal-action">
        <button className="btn btn-ghost" onClick={() => closeModal()}>
          Cancel
        </button>
        <button
          className="btn btn-primary px-6"
          onClick={() => saveNewSchedule()}
          disabled={saving}
        >
          {saving ? (
            <>
              <span className="loading loading-spinner loading-sm"></span>
              Saving...
            </>
          ) : (
            "Save"
          )}
        </button>
      </div>
    </>
  );
}

export default AddScheduleModalBody;
